<template>
  <SPASelect v-model:options="projectStatusOptionsAll" v-model:selected="localSelectedStatusFilter" label="Status" />
</template>

<script>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import SPASelect from '../../../components/SPASelect.vue';
import { useProjectTaggingStore } from '../../../stores/projectTagging';
export default {
  components: {
    SPASelect,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { projectStatusOptions, localSelectedStatusFilter } = storeToRefs(projectTagging);

    const projectStatusOptionsAll = computed(() => {
      let tempArray = projectStatusOptions.value.map((item) => {
        return {
          ...item,
          mdbKey: item.value,
          selected: item.value == 0,
        };
      });

      return [
        {
          text: 'All',
          value: 0,
          mdbKey: 0,
          selected: true,
        },
        ...tempArray,
      ];
    });

    return {
      projectStatusOptionsAll,
      localSelectedStatusFilter,
    };
  },
};
</script>
